export const DEFAULT_PATH = "/22797863291/ca-pub-6877429655236920-tag/"

export const getFullPath = (path) => {
  return `${DEFAULT_PATH}${path}`
}

const REFRESH_INTERVALS = [0, 30, 60, 120, 240]

const getRefreshInterval = () => {
  return REFRESH_INTERVALS[Math.floor(Math.random() * REFRESH_INTERVALS.length)]
}

// Chosen at random at page load
export const currentRefreshInterval = getRefreshInterval()
console.log("AD REFRESH INTERVAL:", currentRefreshInterval)

export const ADS = {
  desktop: {
    abovePlayer: {
      paths: {
        default: "Slideshow_Page_Above_Reader_Incl_Large_Leaderboard_No_Refresh",
        30: "Slideshow_Page_Above_Reader_Incl_Large_Leaderboard_30_Sec_Refresh",
        60: "Slideshow_Page_Above_Reader_Incl_Large_Leaderboard_60_Sec_Refresh",
        120: "Slideshow_Page_Above_Reader_Incl_Large_Leaderboard_120_Sec_Refresh",
        240: "Slideshow_Page_Above_Reader_Incl_Large_Leaderboard_240_Sec_Refresh",
      },
      sizes: [
        [728, 90],
        [970, 90],
      ],
      id: "div-gpt-ad-1660765375782-0",
      shouldRefresh: true,
    },
    aboveRecs: {
      paths: {
        default: "Slideshow_Page_Above_Recs_Desktop_No_Refresh",
        30: "Slideshow_Page_Above_Recs_Desktop_30_Sec_Refresh",
        60: "Slideshow_Page_Above_Recs_Desktop_60_Sec_Refresh",
        120: "Slideshow_Page_Above_Recs_Desktop_120_Sec_Refresh",
        240: "Slideshow_Page_Above_Recs_Desktop_240_Sec_Refresh",
      },
      sizes: [
        [300, 250],
        [200, 200],
        [336, 280],
        [250, 250],
      ],
      id: "div-gpt-ad-1660765673229-0",
      shouldRefresh: true,
    },
  },
  mobile: {
    abovePlayer: {
      paths: {
        default: "Slideshow_Page_Above_Reader_Incl_Large_Mobile_Web_No_Refresh",
        30: "Slideshow_Page_Above_Reader_Incl_Large_Mobile_Web_30_Sec_Refresh",
        60: "Slideshow_Page_Above_Reader_Incl_Large_Mobile_Web_60_Sec_Refresh",
        120: "Slideshow_Page_Above_Reader_Incl_Large_Mobile_Web_120_Sec_Refresh",
        240: "Slideshow_Page_Above_Reader_Incl_Large_Mobile_Web_240_Sec_Refresh",
      },
      sizes: [
        [320, 50],
        [300, 50],
      ],
      id: "div-gpt-ad-1660760137634-0",
      shouldRefresh: true,
    },
    aboveRecs: {
      paths: { default: "Slideshow_Page_Above_Recs_Mobile_Web" },
      sizes: [
        [200, 200],
        [300, 250],
        [250, 250],
        [336, 280],
      ],
      id: "div-gpt-ad-1660760745543-0",
      shouldRefresh: false,
    },
  },
}

export const adStatuses = {
  desktop: {
    abovePlayer: {
      initialized: false,
      filled: false,
      activePath: null,
    },
    aboveRecs: {
      initialized: false,
      filled: false,
      activePath: null,
    },
  },
  mobile: {
    abovePlayer: {
      initialized: false,
      filled: false,
      activePath: null,
    },
    aboveRecs: {
      initialized: false,
      filled: false,
      activePath: null,
    },
  },
}
